// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"12e19e9a","627":"2936e973","738":"fa77bd32","923":"3e279531"}[chunkId] + ".chunk.js";
};